<style lang="scss" scoped>
.invalid-feedback {
  display: block;
}
</style>

<template>
  <div>
    <div
      v-for="(option, value) in options"
      :key="value"
      :class="{ 'is-invalid': hasErrors }"
      class="custom-control custom-radio"
    >
      <input
        class="custom-control-input"
        :name="attribute.name"
        type="radio"
        :id="attribute.name + value"
        :value="value"
        v-model="modelValue"
        :disabled="disabled"
        @change="emitValue(value)"
      />
      <label class="custom-control-label" :for="attribute.name + value">
        {{ option }}
      </label>
    </div>
    <div
      v-if="hasErrors"
      v-for="error in attribute.errors"
      :key="error"
      class="invalid-feedback"
    >
      {{ error }}
    </div>
  </div>
</template>

<script lang="babel">
export default {
  props: {
    value: {
      required: true,
    },
    attribute: {
      required: true,
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      modelValue: this.setModelValue(),
    };
  },
  created() {
    this.emitValue(this.modelValue);
  },
  computed: {
    hasErrors() {
      return this.attribute.errors.length !== 0;
    },
    options() {
      return this.attribute.options;
    }
  },
  methods: {
    setModelValue() {
      if (Array.isArray(this.attribute.options)) {
        return this.attribute.options.reduce((accumulator, option, index) => {
          return accumulator = option === this.value ? index : accumulator;
        }, null);
      }

        return this.value;
    },
    emitValue(value) {
      if (Array.isArray(this.attribute.options)) {
        this.$emit('input', parseFloat(value));
      } else {
        this.$emit('input', value);
      }
    }
  }
}
</script>
